import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.regexp.split.js';
import 'core-js/modules/es6.regexp.constructor.js';
import 'core-js/modules/es6.array.slice.js';
import 'core-js/modules/es6.regexp.replace.js';
import 'core-js/modules/es6.array.fill.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es7.array.includes.js';
import React__default, { forwardRef, useContext, useRef, useMemo, useState, useCallback } from 'react';
import { Classes, Text, Spinner } from '@blueprintjs/core';
import { Icon } from '../icon/icon.js';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';
import { ChevronDown20, CheckboxCheckedFilled20, Checkbox20 } from '@carbon/icons-react';
import cx from 'classnames';
import { usePopper } from 'react-popper';
import useCombinedRefs from '../../utils/use-combined-refs.js';
import { createPortal } from 'react-dom';
import { ascend, pipe, filter, identity, sortWith } from 'ramda';
import { formGroupContext } from '../form-group/form-group.js';
import { makeDefaultModifiers } from '../../utils/popper-modifiers.js';
import { Layers } from '../constants.js';
import { borderRadiusSmall, intentPrimary, textPlaceholder } from '../theme/theme.js';

var _excluded = ["error", "className", "loading", "disabled", "active", "fill", "children", "large", "minimal", "icon", "id"],
    _excluded2 = ["children", "getMenuProps", "popperStyle", "isOpen", "searchInput", "hideContentsWithLoader", "referenceElement", "autoWidthPopover", "containerElement", "containerElementLookup"],
    _excluded3 = ["ref"],
    _excluded4 = ["icon", "tooltip", "className", "active", "multilineItems", "checkbox", "selected", "text", "query"],
    _excluded5 = ["item", "index", "highlightedIndex", "placeholder", "multilineItems", "getIcon", "getItemText", "getItemTooltip"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function highlightText(text, query) {
  var _text;

  text = (_text = text) !== null && _text !== void 0 ? _text : "";
  var lastIndex = 0;
  var words = query.split(/\s+/).filter(function (word) {
    return word.length > 0;
  }).map(escapeRegExpChars);

  if (words.length === 0) {
    return [text];
  }

  var regexp = new RegExp(words.join("|"), "gi");
  var tokens = []; // TODO: potentially fix this while loop since true is always equal to true

  while (true) {
    var match = regexp.exec(text);

    if (!match) {
      break;
    }

    var length = match[0].length;
    var before = text.slice(lastIndex, regexp.lastIndex - length);

    if (before.length > 0) {
      tokens.push(before);
    }

    lastIndex = regexp.lastIndex;
    tokens.push( /*#__PURE__*/React__default.createElement("strong", {
      key: lastIndex
    }, match[0]));
  }

  var rest = text.slice(lastIndex);

  if (rest.length > 0) {
    tokens.push(rest);
  }

  return tokens;
}

function escapeRegExpChars(text) {
  return text.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}

var DropdownButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var error = _ref.error,
      className = _ref.className,
      loading = _ref.loading,
      disabled = _ref.disabled,
      active = _ref.active,
      fill = _ref.fill,
      children = _ref.children,
      large = _ref.large,
      minimal = _ref.minimal,
      IconIncoming = _ref.icon,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, _excluded);

  var internalClassName = cx(Classes.BUTTON, (_cx = {}, _defineProperty(_cx, Classes.ACTIVE, !disabled && active), _defineProperty(_cx, Classes.DISABLED, disabled), _defineProperty(_cx, Classes.FILL, fill), _defineProperty(_cx, Classes.LOADING, loading), _defineProperty(_cx, Classes.LARGE, large), _defineProperty(_cx, Classes.MINIMAL, minimal), _cx), Classes.intentClass(error ? "danger" : undefined), className, "vds-select");
  var formContext = useContext(formGroupContext);

  if (id !== undefined && formContext && id !== (formContext === null || formContext === void 0 ? void 0 : formContext.labelFor)) {
    console.warn("Warning: Select or MultiSelect with id of \"".concat(id, "\" has a parent FormGroup with a missing or mismatched labelFor prop."));
  }

  return /*#__PURE__*/React__default.createElement("button", _extends({
    ref: ref,
    style: {
      minWidth: "4rem"
    },
    className: internalClassName
  }, rest, {
    disabled: disabled,
    id: id ? id : formContext !== null && formContext !== void 0 && formContext.labelId ? "element-".concat(formContext === null || formContext === void 0 ? void 0 : formContext.labelId) : undefined,
    type: "button"
  }), IconIncoming && /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null)), /*#__PURE__*/React__default.createElement(Text, {
    className: cx(Classes.FILL, Classes.BUTTON_TEXT),
    ellipsize: true
  }, children), /*#__PURE__*/React__default.createElement(Icon, null, loading ? /*#__PURE__*/React__default.createElement(Spinner, {
    size: 16
  }) : /*#__PURE__*/React__default.createElement(ChevronDown20, null)));
});
var PortalMenu = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      getMenuProps = _ref2.getMenuProps,
      popperStyle = _ref2.popperStyle,
      isOpen = _ref2.isOpen,
      _ref2$searchInput = _ref2.searchInput,
      searchInput = _ref2$searchInput === void 0 ? null : _ref2$searchInput,
      hideContentsWithLoader = _ref2.hideContentsWithLoader,
      referenceElement = _ref2.referenceElement,
      _ref2$autoWidthPopove = _ref2.autoWidthPopover,
      autoWidthPopover = _ref2$autoWidthPopove === void 0 ? true : _ref2$autoWidthPopove,
      incomingContainerElement = _ref2.containerElement,
      _ref2$containerElemen = _ref2.containerElementLookup,
      containerElementLookup = _ref2$containerElemen === void 0 ? "[data-radix-portal]" : _ref2$containerElemen,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _getMenuProps = getMenuProps(),
      menuRef = _getMenuProps.ref,
      menuProps = _objectWithoutProperties(_getMenuProps, _excluded3);

  var localMenuRef = useRef();

  var wrapperStyles = _objectSpread(_objectSpread({}, popperStyle), {}, {
    minWidth: popperStyle.width,
    borderRadius: borderRadiusSmall,
    display: isOpen ? undefined : "none",
    zIndex: Layers.Popup + 1 // just above basic popover, so this can live inside a popover. Would love not to need this, but because downshift wants the meu item to always exist, it needs this.

  });

  var combinedMenuRef = useCombinedRefs(menuRef, ref, localMenuRef);
  var containerElement = useMemo(function () {
    var _referenceElement$clo;

    return (_referenceElement$clo = referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.closest(containerElementLookup)) !== null && _referenceElement$clo !== void 0 ? _referenceElement$clo : document.body;
  }, [referenceElement, containerElementLookup]);
  return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", _extends({
    ref: combinedMenuRef,
    style: _objectSpread(_objectSpread({}, menuProps.style), wrapperStyles),
    className: cx(Classes.POPOVER, Classes.MINIMAL, "bp3-select-popover", {
      "vds-popover": autoWidthPopover,
      "vds-popover-without-auto-width": !autoWidthPopover
    })
  }, menuProps, {
    onKeyDown: function onKeyDown(e) {
      var _menuProps$onKeyDown;

      // Prevent escape key from propating while menu is open
      if (e.key === "Escape") {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }

      (_menuProps$onKeyDown = menuProps.onKeyDown) === null || _menuProps$onKeyDown === void 0 ? void 0 : _menuProps$onKeyDown.call(menuProps, e);
    },
    onBlur: function onBlur(e) {
      // Checks to see if blur event is caused by clicking inside reference element
      // if so, refocus on the menu element immediately.
      if (e.relatedTarget && referenceElement !== null && referenceElement !== void 0 && referenceElement.contains(e.relatedTarget)) {
        var _localMenuRef$current;

        (_localMenuRef$current = localMenuRef.current) === null || _localMenuRef$current === void 0 ? void 0 : _localMenuRef$current.focus();
      } else {
        var _menuProps$onBlur;

        (_menuProps$onBlur = menuProps.onBlur) === null || _menuProps$onBlur === void 0 ? void 0 : _menuProps$onBlur.call(menuProps, e);
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: Classes.POPOVER_CONTENT
  }, searchInput, /*#__PURE__*/React__default.createElement("ul", _extends({
    className: Classes.MENU,
    style: _objectSpread({
      width: "100%",
      maxWidth: "none",
      overflow: hideContentsWithLoader ? "hidden" : undefined
    }, hideContentsWithLoader ? {
      paddingTop: "2rem",
      paddingBottom: "2rem"
    } : {})
  }, props), hideContentsWithLoader ? /*#__PURE__*/React__default.createElement(Spinner, {
    size: 35
  }) : isOpen && children))), incomingContainerElement !== null && incomingContainerElement !== void 0 ? incomingContainerElement : containerElement);
});
var SelectableListItem = /*#__PURE__*/React__default.forwardRef(function (_ref3, ref) {
  var _cx2;

  var IconIncoming = _ref3.icon,
      tooltip = _ref3.tooltip,
      className = _ref3.className,
      active = _ref3.active,
      multilineItems = _ref3.multilineItems,
      checkbox = _ref3.checkbox,
      selected = _ref3.selected,
      text = _ref3.text,
      query = _ref3.query,
      rest = _objectWithoutProperties(_ref3, _excluded4);

  var displayedText = query !== undefined ? highlightText(text, query) : text;
  var content = /*#__PURE__*/React__default.createElement("li", _extends({
    ref: ref,
    className: cx(Classes.MENU_ITEM, className, (_cx2 = {}, _defineProperty(_cx2, Classes.ACTIVE, active), _defineProperty(_cx2, "vds-select-checkbox", checkbox), _cx2))
  }, rest, {
    "aria-selected": selected
  }), checkbox && /*#__PURE__*/React__default.createElement(Icon, null, selected ? /*#__PURE__*/React__default.createElement(CheckboxCheckedFilled20, {
    style: {
      fill: intentPrimary
    }
  }) : /*#__PURE__*/React__default.createElement(Checkbox20, null)), IconIncoming && /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null)), /*#__PURE__*/React__default.createElement(Text, {
    className: Classes.FILL,
    ellipsize: !multilineItems
  }, displayedText));

  if (tooltip) {
    return /*#__PURE__*/React__default.createElement(TooltipV2, {
      placement: "right",
      content: tooltip
    }, displayedText);
  }

  return content;
});
function defaultItemFilter(options) {
  var query = options.query,
      getItemText = options.getItemText;
  return function (item) {
    if (query) {
      return getItemText(item).toLowerCase().includes(query.toLowerCase());
    }

    return true;
  };
}
function defaultItemSort(options) {
  var getItemText = options.getItemText;
  return ascend(getItemText);
}
function useCommonStuff(_ref4) {
  var _targetAriaProps;

  var _ref4$items = _ref4.items,
      itemsIncoming = _ref4$items === void 0 ? [] : _ref4$items,
      itemFilter = _ref4.itemFilter,
      itemSort = _ref4.itemSort,
      searchInputValue = _ref4.searchInputValue,
      placeholder = _ref4.placeholder,
      getItemId = _ref4.getItemId,
      _ref4$getItemText = _ref4.getItemText,
      getItemText = _ref4$getItemText === void 0 ? getItemId : _ref4$getItemText,
      _ref4$placement = _ref4.placement,
      placement = _ref4$placement === void 0 ? "bottom-end" : _ref4$placement,
      _ref4$matchTargetWidt = _ref4.matchTargetWidth,
      matchTargetWidth = _ref4$matchTargetWidt === void 0 ? true : _ref4$matchTargetWidt,
      label = _ref4.label,
      _onIsOpenChange = _ref4.onIsOpenChange,
      isLoading = _ref4.isLoading,
      loadingPlaceholderItems = _ref4.loadingPlaceholderItems,
      containerElement = _ref4.containerElement,
      containerElementLookup = _ref4.containerElementLookup;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      referenceElement = _useState2[0],
      setReferenceElement = _useState2[1];

  var containedInFormGroup = useContext(formGroupContext);

  if (!containedInFormGroup && !label) {
    throw new Error("Select missing label information.");
  }

  var items = useMemo(function () {
    var processedItems = pipe(itemFilter ? filter(itemFilter({
      query: searchInputValue,
      getItemText: getItemText
    })) : identity, itemSort ? sortWith([itemSort({
      query: searchInputValue,
      getItemText: getItemText
    })]) : identity)(itemsIncoming);

    if (placeholder !== undefined) {
      return [null].concat(_toConsumableArray(processedItems));
    }

    return processedItems;
  }, [itemsIncoming, placeholder, itemFilter, getItemText, itemSort, searchInputValue]);

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      popperElement = _useState4[0],
      setPopperElement = _useState4[1];

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: useMemo(function () {
      return makeDefaultModifiers({
        matchTargetWidth: matchTargetWidth
      });
    }, [matchTargetWidth])
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update;

  var itemToString = useCallback(function (item) {
    if (!item) {
      return placeholder !== null && placeholder !== void 0 ? placeholder : "";
    }

    return getItemText(item);
  }, [getItemText]);
  var safeGetItemId = useCallback(function (item) {
    if (item === null) {
      return "__placeholder";
    }

    return getItemId(item);
  }, [getItemId]);
  var getItemIdByIndex = useCallback(function (index) {
    return safeGetItemId(items[index]);
  }, [safeGetItemId, items]);
  var result = {
    items: items,
    getItemId: safeGetItemId,
    itemToString: itemToString,
    downshiftProps: {
      items: items,
      getItemId: getItemIdByIndex,
      itemToString: itemToString,
      labelId: containedInFormGroup === null || containedInFormGroup === void 0 ? void 0 : containedInFormGroup.labelId,
      inputValue: searchInputValue,
      onIsOpenChange: function onIsOpenChange(changes) {
        var _changes$isOpen;

        return _onIsOpenChange === null || _onIsOpenChange === void 0 ? void 0 : _onIsOpenChange((_changes$isOpen = changes.isOpen) !== null && _changes$isOpen !== void 0 ? _changes$isOpen : false);
      }
    },
    portalMenuProps: _objectSpread(_objectSpread({
      ref: setPopperElement,
      popperStyle: styles.popper
    }, attributes.popper), {}, {
      hideContentsWithLoader: isLoading && loadingPlaceholderItems,
      referenceElement: referenceElement,
      containerElement: containerElement,
      containerElementLookup: containerElementLookup
    }),
    updatePopper: update,
    getMenuPropsEnhancer: function getMenuPropsEnhancer(getMenuProps) {
      return function (options, otherOptions) {
        return _objectSpread(_objectSpread({}, getMenuProps(_objectSpread(_objectSpread({}, options), {}, _defineProperty({}, "aria-label", label)), otherOptions)), {}, _defineProperty({}, "aria-labelledby", label ? undefined : containedInFormGroup === null || containedInFormGroup === void 0 ? void 0 : containedInFormGroup.labelId));
      };
    },
    targetAriaProps: (_targetAriaProps = {}, _defineProperty(_targetAriaProps, "aria-labelledby", undefined), _defineProperty(_targetAriaProps, "aria-label", label ? label : containedInFormGroup === null || containedInFormGroup === void 0 ? void 0 : containedInFormGroup.label), _targetAriaProps),
    referenceElement: referenceElement,
    setReferenceElement: setReferenceElement
  };
  return result;
}

function ComplexItemInternal(_ref5, ref) {
  var item = _ref5.item,
      index = _ref5.index,
      highlightedIndex = _ref5.highlightedIndex,
      placeholder = _ref5.placeholder,
      multilineItems = _ref5.multilineItems,
      getIcon = _ref5.getIcon,
      getItemText = _ref5.getItemText,
      getItemTooltip = _ref5.getItemTooltip,
      itemProps = _objectWithoutProperties(_ref5, _excluded5);

  if (!item) {
    if (!placeholder) {
      throw new Error("If null item provided, must provide a placeholder text.");
    }

    return /*#__PURE__*/React__default.createElement(SelectableListItem, _extends({
      style: {
        color: textPlaceholder,
        fontStyle: "italic"
      },
      active: highlightedIndex === index,
      multilineItems: multilineItems,
      text: placeholder,
      ref: ref
    }, itemProps));
  }

  var tooltip = getItemTooltip === null || getItemTooltip === void 0 ? void 0 : getItemTooltip(item);
  var icon = getIcon === null || getIcon === void 0 ? void 0 : getIcon(item);
  return /*#__PURE__*/React__default.createElement(SelectableListItem, _extends({
    tooltip: tooltip,
    icon: icon,
    active: highlightedIndex === index,
    multilineItems: multilineItems,
    text: getItemText(item),
    ref: ref
  }, itemProps));
}

var ComplexItem = /*#__PURE__*/React__default.forwardRef(ComplexItemInternal);

export { ComplexItem, DropdownButton, PortalMenu, defaultItemFilter, defaultItemSort, highlightText, useCommonStuff };
//# sourceMappingURL=common.js.map
